export default "__VITE_ASSET__CrgM55Cw__"